<template>
  <div class="columns profile--settings">
    <form v-if="!uiFlags.isFetchingItem" @submit.prevent="updateAccount">
      <div class="small-12 row profile--settings--row">
        <div class="columns small-3">
          <h4 class="block-title">
            {{ $t('GENERAL_SETTINGS.FORM.GENERAL_SECTION.TITLE') }}
          </h4>
          <p>{{ $t('GENERAL_SETTINGS.FORM.GENERAL_SECTION.NOTE') }}</p>
        </div>
        <div class="columns small-9 medium-5">
          <label :class="{ error: $v.name.$error }">
            {{ $t('GENERAL_SETTINGS.FORM.NAME.LABEL') }}
            <input
              v-model="name"
              type="text"
              :placeholder="$t('GENERAL_SETTINGS.FORM.NAME.PLACEHOLDER')"
              @blur="$v.name.$touch"
            />
            <span v-if="$v.name.$error" class="message">
              {{ $t('GENERAL_SETTINGS.FORM.NAME.ERROR') }}
            </span>
          </label>
          <label :class="{ error: $v.locale.$error }">
            {{ $t('GENERAL_SETTINGS.FORM.LANGUAGE.LABEL') }}
            <select v-model="locale">
              <option
                v-for="lang in languagesSortedByCode"
                :key="lang.iso_639_1_code"
                :value="lang.iso_639_1_code"
              >
                {{ lang.name }}
              </option>
            </select>
            <span v-if="$v.locale.$error" class="message">
              {{ $t('GENERAL_SETTINGS.FORM.LANGUAGE.ERROR') }}
            </span>
          </label>
          <label v-if="featureInboundEmailEnabled">
            {{ $t('GENERAL_SETTINGS.FORM.FEATURES.INBOUND_EMAIL_ENABLED') }}
          </label>
          <label v-if="featureCustomReplyDomainEnabled">
            {{
              $t('GENERAL_SETTINGS.FORM.FEATURES.CUSTOM_EMAIL_DOMAIN_ENABLED')
            }}
          </label>
          <label v-if="featureCustomReplyDomainEnabled">
            {{ $t('GENERAL_SETTINGS.FORM.DOMAIN.LABEL') }}
            <input
              v-model="domain"
              type="text"
              :placeholder="$t('GENERAL_SETTINGS.FORM.DOMAIN.PLACEHOLDER')"
            />
          </label>
          <label v-if="featureCustomReplyEmailEnabled">
            {{ $t('GENERAL_SETTINGS.FORM.SUPPORT_EMAIL.LABEL') }}
            <input
              v-model="supportEmail"
              type="text"
              :placeholder="
                $t('GENERAL_SETTINGS.FORM.SUPPORT_EMAIL.PLACEHOLDER')
              "
            />
          </label>
          <label
            v-if="showAutoResolutionConfig"
            :class="{ error: $v.autoResolveDuration.$error }"
          >
            {{ $t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_DURATION.LABEL') }}
            <input
              v-model="autoResolveDuration"
              type="number"
              :placeholder="
                $t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_DURATION.PLACEHOLDER')
              "
              @blur="$v.autoResolveDuration.$touch"
            />
            <span v-if="$v.autoResolveDuration.$error" class="message">
              {{ $t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_DURATION.ERROR') }}
            </span>
          </label>

          <label v-if="isAdmin">
            Modelo Empresa → Contatos
            <select v-model="activateCompanies">
              <option :value="false">Desativado</option>
              <option :value="true">Ativado</option>
            </select>
            <span class="help-text">
              Ao ativar essa opção, permite vincular Contatos e Oportunidades a uma Empresa.
            </span>
          </label>
        </div>
      </div>

      <div class="profile--settings--row row">
        <div class="columns small-3">
          <h4 class="block-title">
            {{ $t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.TITLE') }}
          </h4>
          <p>
            {{ $t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.NOTE') }}
          </p>
        </div>
        <div class="columns small-9 medium-5">
          <woot-code :script="getAccountId" />
        </div>
      </div>

      <div class="profile--settings--row row">
        <div class="columns small-3">
          <h4 class="block-title">
            {{ $t('GENERAL_SETTINGS.FORM.ACCOUNT_GID.TITLE') }}
          </h4>
          <p>
            {{ $t('GENERAL_SETTINGS.FORM.ACCOUNT_GID.NOTE') }}
          </p>
        </div>
        <div class="columns small-9 medium-5">
          <woot-code :script="getAccountGid" />
        </div>
      </div>

      <div v-if="canSeeWhatsappCost" class="profile--settings--row row">
        <div class="columns small-3">
          <h4 class="block-title">
            {{ $t('GENERAL_SETTINGS.WHATSAPP_COST.SECTION_TITLE') }}
          </h4>
          <p>{{ $t('GENERAL_SETTINGS.WHATSAPP_COST.SECTION_NOTE') }}</p>
        </div>
        <div class="columns small-9">
          <whatsapp-cost-card />
        </div>
      </div>

      <div class="profile--settings--row row">
        <woot-button
          v-if="!enable2FactorAuthentication"
          type="button"
          @click="toggleModalConnection"
        >
          {{ $t('GENERAL_SETTINGS.AUTH2F.ENABLE') }}
        </woot-button>
        <woot-button v-else type="button" @click="toggleModalVerifyCode">
          {{ $t('GENERAL_SETTINGS.AUTH2F.DISABLE') }}
        </woot-button>
      </div>

      <div class="current-version">
        <div>{{ `v${globalConfig.appVersion}` }}</div>
        <!-- <div v-if="hasAnUpdateAvailable && globalConfig.displayManifest">
          {{
            $t('GENERAL_SETTINGS.UPDATE_CHATWOOT', {
              latestChatwootVersion: latestChatwootVersion,
            })
          }}
        </div> -->
        <div class="build-id">
          <div>{{ `Build ${globalConfig.gitSha}` }}</div>
        </div>
      </div>

      <woot-submit-button
        class="button nice button--fixed-top mt-50 bg-primary"
        :button-text="$t('GENERAL_SETTINGS.SUBMIT')"
        :loading="isUpdating"
      />
    </form>

    <woot-loading-state v-if="uiFlags.isFetchingItem" />
    <modal-conect-auth-2-f
      v-if="openModalConnection"
      :show="openModalConnection"
      :otp-code="otpCode"
      :account-name="name"
      @close="toggleModalConnection"
      @enableAuth2Factor="enableAuth2Factor"
    />

    <woot-modal-verify-code-auth-2-f
      v-if="openModalVerifyCode"
      :show="openModalVerifyCode"
      :email="currentUser.email"
      @close="toggleModalVerifyCode"
      @success-auth-2F="confirmingAuth2F"
    />
  </div>
</template>

<script>
import { getLanguageDirection } from 'dashboard/components/widgets/conversation/advancedFilterItems/languages';
import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import alertMixin from 'shared/mixins/alertMixin';
import configMixin from 'shared/mixins/configMixin';
import { maxValue, minValue, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import accountMixin from '../../../../mixins/account';
import adminMixin from '../../../../mixins/isAdmin';
const semver = require('semver');
import ModalConectAuth2F from './ModalConectAuth2F.vue';
import WhatsappCostCard from './WhatsappCostCard.vue';

export default {
  components: { ModalConectAuth2F, WhatsappCostCard },
  mixins: [accountMixin, adminMixin, alertMixin, configMixin, uiSettingsMixin],
  data() {
    return {
      gid: '',
      id: '',
      name: '',
      locale: 'en',
      domain: '',
      supportEmail: '',
      features: {},
      autoResolveDuration: null,
      latestChatwootVersion: null,
      enable2FactorAuthentication: false,
      activateCompanies: false,
      otpCode: '',
      openModalConnection: false,
      openModalVerifyCode: false,
    };
  },
  validations: {
    name: {
      required,
    },
    locale: {
      required,
    },
    autoResolveDuration: {
      minValue: minValue(1),
      maxValue: maxValue(999),
    },
  },
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
      getAccount: 'accounts/getAccount',
      uiFlags: 'accounts/getUIFlags',
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
    }),
    showAutoResolutionConfig() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.AUTO_RESOLVE_CONVERSATIONS
      );
    },
    // Card de custo WhatsApp: admin real (não-supervisor) sempre; supervisor só
    // com a permissão `see_whatsapp_cost` concedida (US-4490).
    canSeeWhatsappCost() {
      const u = this.currentUser || {};
      if (u.type === 'SuperAdmin') return true;
      if (u.permissions && u.permissions.see_whatsapp_cost) return true;
      return this.isAdmin && u.type_role !== 'supervisor';
    },
    hasAnUpdateAvailable() {
      if (!semver.valid(this.latestChatwootVersion)) {
        return false;
      }

      return semver.lt(
        this.globalConfig.appVersion,
        this.latestChatwootVersion
      );
    },
    languagesSortedByCode() {
      const enabledLanguages = [...this.enabledLanguages];
      return enabledLanguages.sort((l1, l2) =>
        l1.iso_639_1_code.localeCompare(l2.iso_639_1_code)
      );
    },
    isUpdating() {
      return this.uiFlags.isUpdating;
    },

    featureInboundEmailEnabled() {
      return !!this.features.inbound_emails;
    },

    featureCustomReplyDomainEnabled() {
      return (
        this.featureInboundEmailEnabled && !!this.features.custom_reply_domain
      );
    },

    featureCustomReplyEmailEnabled() {
      return (
        this.featureInboundEmailEnabled && !!this.features.custom_reply_email
      );
    },

    getAccountId() {
      return this.id.toString();
    },

    getAccountGid() {
      return this.gid.toString();
    },
  },
  mounted() {
    if (!this.id && !this.gid) {
      this.initializeAccount();
    }
  },
  methods: {
    toggleModalConnection() {
      this.openModalConnection = !this.openModalConnection;
    },
    toggleModalVerifyCode() {
      if (this.currentUser?.type === 'SuperAdmin') {
        this.enable2FactorAuthentication = false;
        this.updateAccount();
        return;
      }
      this.openModalVerifyCode = !this.openModalVerifyCode;
    },
    async initializeAccount() {
      try {
        await this.$store.dispatch('accounts/get');
        const {
          gid,
          name,
          locale,
          id,
          domain,
          support_email,
          features,
          auto_resolve_duration,
          latest_chatwoot_version: latestChatwootVersion,
          enable_2_factor_authentication,
          otp_code,
          activate_companies,
        } = this.getAccount(this.accountId);

        this.otpCode = otp_code;
        this.$root.$i18n.locale = locale;
        this.gid = gid;
        this.name = name;
        this.locale = locale;
        this.id = id;
        this.domain = domain;
        this.supportEmail = support_email;
        this.features = features;
        this.autoResolveDuration = auto_resolve_duration;
        this.latestChatwootVersion = latestChatwootVersion;
        this.enable2FactorAuthentication = enable_2_factor_authentication;
        this.activateCompanies = !!activate_companies;
      } catch (error) {
        // Ignore error
      }
    },

    enableAuth2Factor() {
      this.enable2FactorAuthentication = true;
      this.updateAccount();
      this.toggleModalConnection();
    },

    confirmingAuth2F() {
      this.enable2FactorAuthentication = false;
      this.toggleModalVerifyCode();
      this.updateAccount();
    },

    async updateAccount() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showAlert(this.$t('GENERAL_SETTINGS.FORM.ERROR'));
        return;
      }
      try {
        await this.$store.dispatch('accounts/update', {
          locale: this.locale,
          name: this.name,
          domain: this.domain,
          support_email: this.supportEmail,
          auto_resolve_duration: this.autoResolveDuration,
          enable_2_factor_authentication: this.enable2FactorAuthentication,
          activate_companies: this.activateCompanies,
          user_id: this.currentUser?.id,
        });
        await this.$store.dispatch('accounts/get');
        await this.initializeAccount();
        this.$root.$i18n.locale = this.locale;
        this.getAccount(this.id).locale = this.locale;
        this.updateDirectionView(this.locale);
        this.showAlert(this.$t('GENERAL_SETTINGS.UPDATE.SUCCESS'));
      } catch (error) {
        this.showAlert(this.$t('GENERAL_SETTINGS.UPDATE.ERROR'));
      }
    },

    updateDirectionView(locale) {
      const isRTLSupported = getLanguageDirection(locale);
      this.updateUISettings({
        rtl_view: isRTLSupported,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/variables.scss';
@import '~dashboard/assets/scss/mixins.scss';

input[type='checkbox'] {
  margin: 0;
}

.code--action-area .tiny {
  background-color: var(--g-20);
  color: var(--s-50);
}

.profile--settings {
  padding: 24px;
  overflow: auto;
}

.profile--settings--row {
  @include border-normal-bottom;
  padding: $space-normal;
  .small-3 {
    padding: $space-normal $space-medium $space-normal 0;
  }
  .small-9 {
    padding: $space-normal;
  }
}

.current-version {
  font-size: var(--font-size-small);
  text-align: center;
  padding: var(--space-normal);
}
</style>
